export default [
  {
    routeName: 'user_module_comsaReports_power_use',
    title: 'power.use',
    type: 'powerUse',
    icon: 'lightbulb',
    color: '#17A2B8',
  },
  {
    routeName: 'user_module_comsaReports_fuel_use',
    title: 'fuel.use',
    type: 'fuelUse',
    icon: 'oil',
    color: '#6C757D',
  },
  {
    routeName: 'user_module_comsaReports_water_use',
    title: 'water.use',
    type: 'waterUse',
    icon: 'drop',
    color: '#007bff',
  },
  {
    routeName: 'user_module_comsaReports_paper_use',
    title: 'paper.use',
    type: 'paperUse',
    icon: 'file-list-3',
    color: '#6C757D',
  },
  {
    routeName: 'user_module_comsaReports_natural_gas_use',
    title: 'natural.gas.use',
    type: 'naturalGasUse',
    icon: 'gas-station',
    color: '#FFC107',
  },
  {
    routeName: 'user_module_comsaReports_cooling_gas_use',
    title: 'cooling.gas.use',
    type: 'coolingGasUse',
    icon: 'airplay',
    color: '#FFC107',
  },
  {
    routeName: 'user_module_comsaReports_water_waste',
    title: 'water.waste',
    type: 'waterWaste',
    icon: 'blur-off',
    color: '#007bff',
  },
  {
    routeName: 'user_module_comsaReports_waste_management',
    title: 'waste.management',
    type: 'wasteManagement',
    icon: 'delete-bin-7',
    color: '#343A40',
  },
  {
    routeName: 'user_module_comsaReports_natural_resources_use_reduction',
    title: 'natural.resources.use.reduction',
    type: 'naturalResourcesUseReduction',
    icon: 'scissors',
    color: '#28A745',
  },
  {
    routeName: 'user_module_comsaReports_landscape_restoration',
    title: 'landscape.restoration',
    type: 'landscapeRestoration',
    icon: 'landscape',
    color: '#28A745',
  },
  {
    routeName: 'user_module_comsaReports_energy_efficiency',
    title: 'energy-efficiency',
    type: 'energyEfficiency',
    icon: 'exchange-funds',
    color: '#B87333',
  },
  {
    routeName: 'user_module_comsaReports_waste_recovery',
    title: 'waste-recovery',
    type: 'wasteRecovery',
    icon: 'truck',
    color: '#239151',
  },
  {
    routeName: 'user_module_comsaReports_carbon_footprint',
    title: 'carbon-footprint',
    type: 'carbonFootprint',
    icon: 'fingerprint',
    color: '#9d8bf0',
  },
  {
    routeName: 'user_module_comsaReports_recycled_packaging_material',
    title: 'recycled-packaging-material',
    type: 'recycledPackagingMaterial',
    icon: 'recycle',
    color: '#5de3af',
  },
  {
    routeName: 'user_module_comsaReports_tertiary_packaging',
    title: 'tertiary-packaging',
    type: 'tertiaryPackaging',
    icon: 'red-packet',
    color: '#f542a1',
  },
  {
    routeName: 'user_module_comsaReports_food_waste',
    title: 'food-waste',
    type: 'foodWaste',
    icon: 'cake-3',
    color: '#e8b976',
  },
  {
    routeName: 'user_module_comsaReports_energy_certificate',
    title: 'energy-certificate',
    type: 'energyCertificate',
    icon: 'article',
    color: '#17A2B8',
  },
  {
    routeName: 'user_module_comsaReports_electric_charger',
    title: 'electric-charger',
    type: 'electricCharger',
    icon: 'wireless-charging',
    color: '#B87333',
  },
  {
    routeName: 'user_module_comsaReports_goodLogisticsPractices',
    title: 'good-logistics-practices',
    type: 'goodLogisticsPractices',
    icon: 'bus',
    color: '#C909DE',
  },
  {
    routeName: 'user_module_comsaReports_occupation',
    title: 'occupation',
    type: 'occupation',
    icon: 'user',
    color: '#92dceeff',
  },
  {
    routeName: 'user_module_comsaReports_recycledPaper',
    title: 'recycled-paper',
    type: 'recycledPaper',
    icon: 'file-paper',
    color: '#c1fa93ff',
  },
  {
    routeName: 'user_module_comsaReports_nonRecycledPaper',
    title: 'non-recycled-paper',
    type: 'nonRecycledPaper',
    icon: 'file-list',
    color: '#fa9393ff',
  },
  {
    routeName: 'user_module_comsaReports_biodiversity',
    title: 'biodiversity',
    type: 'biodiversity',
    icon: 'atom',
    color: '#5de3af',
  },
  // {
  //   routeName: 'user_module_comsaReports_recycled_packaging_material',
  //   title: 'recycled-packaging-material',
  //   type: 'recycledPackagingMaterial',
  //   icon: 'recycle',
  //   color: '#5de3af',
  // },
];
